import React from "react"

const Phone = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3451 12.6641L12.707 14.7118C10.1699 13.2208 8.05547 11.1066 6.56416 8.56962L8.61194 6.93154C9.10539 6.53639 9.27049 5.85829 9.01394 5.28054L7.14706 1.07742C6.87073 0.454647 6.18413 0.123508 5.52472 0.294985L1.97186 1.21668C1.28557 1.39598 0.841874 2.06026 0.939117 2.76288C2.22029 11.8855 9.39053 19.0556 18.5134 20.3367C19.2159 20.4337 19.8799 19.9901 20.0592 19.304L20.9809 15.7508C21.1521 15.0915 20.8213 14.4053 20.1989 14.1285L15.9962 12.2621C15.4184 12.0054 14.7402 12.1705 14.3451 12.6641Z"
        fill="#34A0B6"
      />
    </svg>
  )
}

export default Phone
